export default __webpack_public_path__ + "static/media/forestly-expl-gradcam-06_EN.e60baa8c.png";